import React from "react"
import styled from "styled-components"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { renderRichText } from "gatsby-source-contentful/rich-text"

// Utils
import { richTextOptions } from "@utils/knowledge-center"

const DefinitionContainer = styled.div`
  margin-top: 48px;

  .title {
    color: var(--alt-black) !important;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    border-top: ${props => `2px solid ${props.categoryColor}`};
    border-left: ${props => `2px solid ${props.categoryColor}`};
    border-right: ${props => `2px solid ${props.categoryColor}`};
    padding: 12px 24px 8px;
  }

  .type {
    color: ${props => props.categoryColor};
    font-size: 20px;
    line-height: 32px;
  }

  .definition {
    margin-top: 8px;
    color: #2d3748 !important;
    font-size: 20px;
    line-height: 32px;
    padding: 0 24px;

    p {
      display: inline;
    }
  }
`

const ArticleDefinition = props => {
  const CategoryColor = () => {
    if (props.category === "finances") {
      return "#077577"
    }
    if (props.category === "mortgages") {
      return "#007AB4"
    }
    if (props.category === "homeownership") {
      return "#BD432B"
    }
  }
  return (
    <DefinitionContainer
      className="article-definition article-component"
      categoryColor={CategoryColor()}
    >
      <div className="text">
        <p className="title">{props.fields.title}</p>
        <div className="definition">
          <span className="type">{`${props.fields.type.toUpperCase()}  `}</span>
          {/* {documentToReactComponents(JSON.parse(props.fields.definition.raw))} */}
          {renderRichText(props.fields.definition, richTextOptions(props))}
        </div>
      </div>
    </DefinitionContainer>
  )
}

export default ArticleDefinition
